// extracted by mini-css-extract-plugin
export default {"button":"ButtonPill_button__JqHZt","icon":"ButtonPill_icon__Lx19-","appleBlue":"ButtonPill_appleBlue__QQZsh","ui-spin":"ButtonPill_ui-spin__-9MIA"};